import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { env } from "../env";
import { getLocalStorage } from "../utils/function/localStorage";

export const pointTransferApi = createApi({
  reducerPath: "pointTransferApi",
  baseQuery: fetchBaseQuery({
    baseUrl: env.BASE_URL,
    prepareHeaders: (headers) => {
      headers.set("X-Auth-Token", getLocalStorage("tp_Aa_uth_access"));
      return headers;
    },
  }),
  tagTypes: ["PointTransfer"],
  endpoints: (builder) => ({
    transferModeratorPoints: builder.mutation({
      query: (data) => ({
        url: "/secure/moderator-point-transfer",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["PointTransfer"],
    }),
    getModeratorPointTransferHistory: builder.query({
      query: ({ page = 1, limit = 10, searchUsername = "" }) => ({
        url: "/secure/moderator-point-transfer-history",
        method: "GET",
        params: { page, limit, searchUsername },
      }),
      providesTags: ["PointTransfer"],
    }),
  }),
});

export const { 
  useTransferModeratorPointsMutation,
  useLazyGetModeratorPointTransferHistoryQuery 
} = pointTransferApi;